import React from 'react';

import type {SerializedError} from '@reduxjs/toolkit';
import type {FetchBaseQueryError} from '@reduxjs/toolkit/dist/query';

export interface FormErrorsContextType {
  formErrors: Record<string, Array<string>>;
  setFormErrors: (
    errors: Record<string, Array<string>>,
    append?: boolean
  ) => void;
  captureFormErrorsFromRejection: (
    err?: SerializedError | FetchBaseQueryError | Error,
    append?: boolean
  ) => void;
}

export const FormErrorsContext = React.createContext<FormErrorsContextType>({
  formErrors: {},
  setFormErrors: () => undefined,
  captureFormErrorsFromRejection: () => undefined,
});
